import callApi from 'utils/callApi';

// Requests
export function requestBulk(payload) {
  return callApi('bulk/main/', 'POST', payload);
}

export function requestWorkflowBulk(payload) {
  return callApi('workflow/workflow_bulk/', 'POST', payload);
}



// WEBPACK FOOTER //
// ./src/redux/modules/bulk.js